/**
 * Fallback: hide Quick View buttons by visible label (when href-based CSS is not enough).
 *
 * Add before </body> in theme.liquid OR as an app embed (custom liquid) — load after main JS.
 * Only touches nodes inside #ShopNowContainer.
 */
(function () {
  var LABELS = ["email us for details", "purchase seats"];

  function hideMatching(root) {
    if (!root) return;
    var nodes = root.querySelectorAll("a, button");
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var t = (el.textContent || "").trim().toLowerCase();
      for (var j = 0; j < LABELS.length; j++) {
        if (t.indexOf(LABELS[j]) !== -1) {
          el.style.setProperty("display", "none", "important");
          break;
        }
      }
    }
  }

  function observe() {
    var c = document.getElementById("ShopNowContainer");
    if (!c) return;
    hideMatching(c);
    var mo = new MutationObserver(function () {
      hideMatching(c);
    });
    mo.observe(c, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observe);
  } else {
    observe();
  }
})();
